import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { reducer } from './store/outlook-auth.reducers';
import { OutlookAuthEffects } from './store/outlook-auth.effects';

@NgModule({
  imports: [
    EffectsModule.forFeature([ OutlookAuthEffects ]),
    StoreModule.forFeature('outlookAuth', reducer),
  ],
})
export class OutlookAuthModule {}
